export default __webpack_public_path__ + "static/B0016-0c65acc4b676fcfbe0f3abad6051c017.png";